
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class ErrorHelper extends Vue {

    public excludedErrors: Array<{type: string; regex: string; }> = 
    [
        {
            type: 'Unauthenticated',
            regex: '^Unauthenticated\.$',
        },
        {
            type: 'File not found',
            regex: 'File not found at path:',
        },
    ];

    public showErrorDialog(errorMessage: string) {
        let showDialog = true;
        this.excludedErrors.map((error) => {
            if (errorMessage.match(error.regex)) {
                showDialog = false;
                return;
            }
        });
        return showDialog;
    }
}
